<template>
    <span
        :style="style"
        class="label"
    >
        {{ statusName }}
    </span>
</template>
<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'status-v2',
    props: {
        status: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),
        statusName() {
            return this.getTranslatedStr(this.status, 'name', this.status.name);
        },
        style() {
            return {
                backgroundColor: this.status.backgroundColor,
                color: this.status.textColor,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.label {
    position: static;
    color: $white-color;
    padding: 1px 10px 1px;
    font-size: 1.1rem;
    font-weight: 700;
    width: auto;
    border-radius: 10px;
}
</style>